/* eslint-disable */
import TweenMax from 'TweenMax';
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';

(function($){

    $.fn.initScrollMagic = function (options) {

        var defaults = {}
        var settings = $.extend(defaults, options);

		var windowHeight = $(window).height();
        var windowWidth = $(window).width();
        var documentHeight = $(document).height();

        /* ***** ScrollMagic - Global Variable ***** */
        var smOffsetAnimation = -((windowHeight / 10) * 3.5);
        var smOffsetAnimationTop = (windowHeight / 10) * 3.5;
        var smDurationAnimation = 100;
        var smTimeAnimation = 0.6;
        var smDelayAnimation = 0;
        var smDataDurationAnimation;
        var smDataX;
        var smDataY;
        var controllerSMAnimation;
        var countSMAnimation;
        var thisSMAnimation;
        var tweenSMAnimation;
        var sceneSMAnimation;
        var controllerSMWidthFull;
        var countSMWidthFull;
        var thisSMWidthFull;
        var tweenSMWidthFull;
        var sceneSMWidthFull;
        var controllerSMSvgDraw;
        var countSMSvgDraw;
        var thisSMSvgDraw;
        var SMSvgDrawPath1;
        var SMSvgDrawPath2;
        var tweenSMSvgDraw;
        var sceneSMSvgDraw;
        var controllerSMSectionWipe;
        var countSMSectionWipe;
        var thisSMSectionWipe;
        var tweenSMSectionWipe;
        var sceneSMSectionWipe;
        var controllerSMToggleClass;
        var controllerSMToggleClass;
        var countSMToggleClass;
        var thisSMToggleClass;
        var thisSMDataToggleClass;
        var valueSMToggleClass;
        var dataSMToggleClass;
        var boolReverseSMToggleClass;
        var sceneSMToggleClass;
        var controllerSMPinTopBool = false;
        var controllerSMPinTop;
        var countSMPinTop;
        var thisSMPinTop;
        var valueOffsetHalf;
		var sceneSMPinTop;
		var controllerSMParallax;
        var countSMParallax;
        var thisSMParallax;
        var tweenSMParallax;
        var sceneSMParallax;
		var smParallaxDataRotate;
		var smParallaxDataScale;
        var smParallaxDataX;
        var smParallaxDataY;
        var progressSM;
		var smParallaxValuePosition;
		var smOffsetAnimationData;

		var controllerSMParallaxEnter;
        var countSMParallaxEnter;
		var thisSMParallaxEnter;
        var tweenSMParallaxEnter;
        var sceneSMParallaxEnter;
		var smParallaxEnterDataY;

        var thisSMFollowPage;
        var countSMFollowPage;
        var sceneSMFollowPage;
        var controllerSMFollowPage;
        var tweenSMFollowPage;
        var controllerSMCountUp;
        var countSMCountUp;
        var tweenSMCountUp;
        var thisSMCountUp;

        //function definitions:
        function _init(self) {
                smOffsetAnimation = -((windowHeight / 10) * 3.5);
                smOffsetAnimationTop = (windowHeight / 10) * 3.5;
                /* ********** ScrollMagic - Animation ********** */
                /*if($('.scrollmagic-animation').length){
                    if(controllerSMAnimation != null){
                        controllerSMAnimation.destroy();
                        controllerSMAnimation = null;
                    }

                    controllerSMAnimation = new ScrollMagic.Controller();

                    countSMAnimation = 0;
                    $(".scrollmagic-animation").each(function(index){
                        thisSMAnimation = $(this);
                        thisSMAnimation.addClass('scrollmagic-animation-'+countSMAnimation);

                        // ***** ScrollMagic - Data Delay
                        if(thisSMAnimation.data("sm-delay") !== undefined){
                            smDelayAnimation = thisSMAnimation.data("sm-delay");
                        }else{
                            smDelayAnimation = 0;
                        }

                        // ***** Tween ScrollMagic
                        if(thisSMAnimation.hasClass('scrollmagic-animation-y')){
                            /* ***** ScrollMagic - Data Y ***** */
                            /*if(thisSMAnimation.data("sm-y") !== undefined){
                                smDataY = thisSMAnimation.data("sm-y");
                            }else{
                                smDataY = 100;
                            }

                            // Tween ScrollMagic - Bottom
                            tweenSMAnimation = TweenMax.fromTo(thisSMAnimation, smTimeAnimation, {autoAlpha:0, y:smDataY, ease: Circ.easeIn}, {delay:smDelayAnimation, autoAlpha:1, y:0, ease: Circ.easeOut});
                        }else{
                            // Tween ScrollMagic - Opacity = Default Tween
                            tweenSMAnimation = TweenMax.fromTo(thisSMAnimation, smTimeAnimation, {autoAlpha: 0, ease: Circ.easeInOut}, {delay:smDelayAnimation, autoAlpha: 1, ease: Circ.easeInOut});
                        }

                        // ***** Scene ScrollMagic Animation
                        sceneSMAnimation = new ScrollMagic.Scene({
                            triggerElement: '.scrollmagic-animation-'+countSMAnimation,
                            offset: smOffsetAnimation
                        })
                        .setTween(tweenSMAnimation);

                        controllerSMAnimation.addScene(sceneSMAnimation);
                        countSMAnimation++;
                    });
                }*/

                /* ***** ScrollMagic - Width to Full ***** */
                /*if($('.scrollmagic-width-full').length){
                    controllerSMWidthFull = new ScrollMagic.Controller();

                    countSMWidthFull = 0;
                    $(".scrollmagic-width-full").each(function(index){
                        thisSMWidthFull = $(this);
                        thisSMWidthFull.addClass('scrollmagic-width-full-'+countSMWidthFull);

                        // ScrollMagic - Delay
                        if(thisSMWidthFull.data("sm-delay") !== undefined){
                            smDelayAnimation = thisSMWidthFull.data("sm-delay");
                        }else{
                            smDelayAnimation = 0;
                        }
                        smTimeAnimation += 0.4;

                        tweenSMWidthFull = TweenMax.from(thisSMWidthFull, smTimeAnimation, {delay:smDelayAnimation, width:0, ease: Circ.easeOut});

                        sceneSMWidthFull = new ScrollMagic.Scene({
                            triggerElement: '.scrollmagic-width-full-'+countSMWidthFull,
                            offset: smOffsetAnimation
                        })
                        .setTween(tweenSMWidthFull);

                        controllerSMWidthFull.addScene(sceneSMWidthFull);
                        countSMWidthFull++;
                    });
                }*/

                /* ***** ScrollMagic - Svg Draw ***** */
                /*if($('.scrollmagic-svg-draw').length){
                    controllerSMSvgDraw = new ScrollMagic.Controller();

                    countSMSvgDraw = 0;
                    $(".scrollmagic-svg-draw").each(function(index){
                        thisSMSvgDraw = $(this);

                        thisSMSvgDraw.addClass('scrollmagic-svg-draw-'+countSMSvgDraw);

                        SMSvgDrawPath1 = thisSMSvgDraw.find("#path1");
                        SMSvgDrawPath2 = thisSMSvgDraw.find("#path2");
                        pathPrepare(SMSvgDrawPath1);
                        pathPrepare(SMSvgDrawPath2);

                        tweenSMSvgDraw = new TimelineMax()
                        .add(TweenMax.to(path1, 0.8, {strokeDashoffset: 0, ease: Power2.easeOut}))
                        .add(TweenMax.to(path2, 0.2, {strokeDashoffset: 0, ease: Power2.easeOut}));

                        sceneSMSvgDraw = new ScrollMagic.Scene({triggerElement: '.scrollmagic-svg-draw-'+countSMSvgDraw, duration: smDurationAnimation, offset: smOffsetAnimation, tweenChanges: true})
                        .setTween(tweenSMSvgDraw)
                        .addTo(controllerSMSvgDraw);

                        countSMSvgDraw++;
                    });
                }*/

                /* ***** ScrollMagic - Section Wipe ***** */
                /*if($('.scrollmagic-section-wipe').length){
                    controllerSMSectionWipe = new ScrollMagic.Controller({
                        globalSceneOptions: {
                            triggerHook: 'onLeave'
                        }
                    });

                    countSMSectionWipe = 0;
                    $(".scrollmagic-section-wipe").each(function(index){
                        thisSMSectionWipe = $(this);

                        thisSMSectionWipe.addClass('scrollmagic-section-wipe-'+countSMSectionWipe);

                        tweenSMSectionWipe = new TimelineMax()
                        .add(TweenMax.to(path1, 0.8, {strokeDashoffset: 0, ease: Power2.easeOut}))
                        .add(TweenMax.to(path2, 0.2, {strokeDashoffset: 0, ease: Power2.easeOut}));

                        sceneSMSectionWipe = new ScrollMagic.Scene({
                            triggerElement: '.scrollmagic-section-wipe-'+countSMSectionWipe
                        })
                        .setPin('.scrollmagic-section-wipe-'+countSMSectionWipe)
                        .addTo(controllerSMSectionWipe);

                        countSMSectionWipe++;
                    });
                }*/

				/* ***** ScrollMagic - Toggle Class ***** */
				$('.sa').addClass('sa-init');
				setTimeout(function () {
					if($('.sa').length){

						if(controllerSMToggleClass != null){
							controllerSMToggleClass.destroy(reset);
							controllerSMToggleClass = null;

							sceneSMToggleClass.destroy(reset);
							sceneSMToggleClass = null;
						}

						controllerSMToggleClass = new ScrollMagic.Controller();

						countSMToggleClass = 0;
						$(".sa").each(function(index){

							boolReverseSMToggleClass = false;
							thisSMToggleClass = $(this);
							thisSMDataToggleClass = thisSMToggleClass.data("sm-target-toggle-class");

							dataSMToggleClass = thisSMToggleClass.data("sm-toggle-class");
							if(dataSMToggleClass == undefined){
								dataSMToggleClass = 'sa-active';
							}

							thisSMToggleClass.addClass('sa-'+countSMToggleClass);
							//thisSMToggleClass.addClass('sa-init');

							if(thisSMDataToggleClass == undefined){
								valueSMToggleClass = '.sa-'+countSMToggleClass;
							}else{
								valueSMToggleClass = thisSMDataToggleClass;
								boolReverseSMToggleClass = true;
							}

							valueOffsetHalf = thisSMToggleClass.height();
							if(thisSMToggleClass.data("sm-duration") !== undefined){
								smDataDurationAnimation = $(thisSMToggleClass.data("sm-duration")).outerHeight();
							}else{
								smDataDurationAnimation = 0;
							}

							smOffsetAnimation = -((windowHeight / 10) * 2);
							smOffsetAnimationData = thisSMToggleClass.data("sm-offset");
							if(smOffsetAnimationData != undefined){
								if(smOffsetAnimationData.indexOf("%") >= 0){
									smOffsetAnimationData = smOffsetAnimationData.replace("%","");
									smOffsetAnimationData = (smOffsetAnimationData * $(window).outerHeight()) / 100;
								}
								smOffsetAnimation = smOffsetAnimation - smOffsetAnimationData;
							}

							if(boolReverseSMToggleClass == true){
								sceneSMToggleClass = new ScrollMagic.Scene({triggerElement: '.sa-'+countSMToggleClass, offset: smOffsetAnimation, duration:smDataDurationAnimation})
								.setClassToggle(valueSMToggleClass, dataSMToggleClass) // add class toggle
								.addTo(controllerSMToggleClass);
							}else{
								sceneSMToggleClass = new ScrollMagic.Scene({triggerElement: '.sa-'+countSMToggleClass, offset: smOffsetAnimation, duration:smDataDurationAnimation})
								.setClassToggle(valueSMToggleClass, dataSMToggleClass) // add class toggle
								.reverse(false)
								.addTo(controllerSMToggleClass);
							}

							countSMToggleClass++;
						});
					}
				}, 800);

                /* ***** ScrollMagic - Pin Top ***** */
                if($('.scrollmagic-pin-top').length){
                    controllerSMPinTop = new ScrollMagic.Controller();

                    countSMPinTop = 0;
                    if(windowWidth > 767 && controllerSMPinTopBool == false){
                        controllerSMPinTopBool = true;
                        $(".scrollmagic-pin-top").each(function(index){
                            thisSMPinTop = $(this);

                            /* ScrollMagic - Duration */
							valueOffsetHalf = windowHeight / 2;
                            //valueOffsetHalf = thisSMPinTop.height();

                            if(thisSMPinTop.data("sm-duration") !== undefined){
                                smDataDurationAnimation = $(thisSMPinTop.data("sm-duration")).height();
                            }else{
                                smDataDurationAnimation = 0;
                            }

                            valueOffsetHalf = valueOffsetHalf;

                            /*smOffsetAnimation = -(($(window).height() / 10) * 4.5);*/
                            smOffsetAnimation = valueOffsetHalf;
                            smOffsetAnimationData = thisSMPinTop.data("sm-offset");
                            if(smOffsetAnimationData != undefined){
                                if(smOffsetAnimationData.indexOf("%") >= 0){
                                    smOffsetAnimationData = smOffsetAnimationData.replace("%","");
                                    smOffsetAnimationData = (smOffsetAnimationData * $(window).outerHeight()) / 100;
                                }
                                smOffsetAnimation = smOffsetAnimation - smOffsetAnimationData;
                            }

                            if(smDataDurationAnimation >= 0){

                                thisSMPinTop.addClass('scrollmagic-pin-top-'+countSMPinTop);

                                sceneSMPinTop = new ScrollMagic.Scene({triggerElement: '.scrollmagic-pin-top-'+countSMPinTop, duration: smDataDurationAnimation, offset: smOffsetAnimation })
                                    .setClassToggle('.scrollmagic-pin-top-'+countSMPinTop, "scrollmagic-pin-top-active") // add class toggle
                                    .setPin('.scrollmagic-pin-top-'+countSMPinTop, {pushFollowers: false})
                                    .addTo(controllerSMPinTop);

                                countSMPinTop++;
                            }
                        });
                    }
                }

                /* ***** ScrollMagic - Parallax ***** */
				if ($('.scrollmagic-parallax').length) {
					if(windowWidth > 767){

						controllerSMParallax = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "170%"}});

						countSMParallax = 0;
						$(".scrollmagic-parallax").each(function (index) {
							thisSMParallax = $(this);

							thisSMParallax.addClass('scrollmagic-parallax-' + countSMParallax);

							/* ***** ScrollMagic - Parallax Data Rotate ***** */
							if (thisSMParallax.data("sm-parallax-rotate") !== undefined) {
								smParallaxDataRotate = thisSMParallax.data("sm-parallax-rotate") / 2;

								tweenSMParallax = TweenMax.fromTo(thisSMParallax, 1, {rotate: -smParallaxDataRotate, ease: Power0.easeIn}, {rotate: smParallaxDataRotate, ease: Power0.easeOut});
							} else {
								smParallaxDataX = 100 / 2;
							}

							/* ***** ScrollMagic - Parallax Data Scale ***** */
							if (thisSMParallax.data("sm-parallax-scale") !== undefined) {
								smParallaxDataScale = thisSMParallax.data("sm-parallax-scale");

								tweenSMParallax = TweenMax.fromTo(thisSMParallax, 1, {scaleX: smParallaxDataScale, scaleY: smParallaxDataScale, ease: Power0.easeIn}, {scaleX: 1, scaleY: 1, ease: Power0.easeOut});
							} else {
								smParallaxDataX = 100 / 2;
							}

							/* ***** ScrollMagic - Parallax Data X ***** */
							if (thisSMParallax.data("sm-parallax-x") !== undefined) {
								smParallaxDataX = thisSMParallax.data("sm-parallax-x") / 2;

								tweenSMParallax = TweenMax.fromTo(thisSMParallax, 1, {x: -smParallaxDataX, ease: Power0.easeIn}, {x: smParallaxDataX, ease: Power0.easeOut});
							} else {
								smParallaxDataX = 100 / 2;
							}

							/* ***** ScrollMagic - Parallax Data Y ***** */
							if (thisSMParallax.data("sm-parallax-y") !== undefined) {
								smParallaxDataY = thisSMParallax.data("sm-parallax-y") / 2;

								tweenSMParallax = TweenMax.fromTo(thisSMParallax, 1, {y: -smParallaxDataY, ease: Power0.easeIn}, {y: smParallaxDataY, ease: Power0.easeOut});
							} else {
								smParallaxDataY = 100 / 2;
							}

							if (thisSMParallax.data("sm-parallax-x") !== undefined && thisSMParallax.data("sm-parallax-y") !== undefined) {
								tweenSMParallax = TweenMax.fromTo(thisSMParallax, 1, {x: -smParallaxDataX, y: -smParallaxDataY, ease: Power0.easeIn}, {x: smParallaxDataX, y: smParallaxDataY, ease: Power0.easeOut});
							}

							if (thisSMParallax.data("sm-parallax-opacity") !== undefined) {
								tweenSMParallax = TweenMax.fromTo(thisSMParallax, 1, {opacity: 0, ease: Power0.easeIn}, {opacity: 1, ease: Power0.easeOut});
							}

							sceneSMParallax = new ScrollMagic.Scene({triggerElement: '.scrollmagic-parallax-' + countSMParallax})
									.setTween(tweenSMParallax)
									.addTo(controllerSMParallax);

							countSMParallax++;
						});
					}
				}
				
				/* ***** ScrollMagic - Parallax Enter ***** */
                if($('.scrollmagic-parallax-enter').length){
                    controllerSMParallaxEnter = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: "onEnter", duration: "45%"}});

                    if(windowWidth > 767){

                        countSMParallaxEnter = 0;
                        $(".scrollmagic-parallax-enter").each(function(index){
                            thisSMParallaxEnter = $(this);

                            thisSMParallaxEnter.addClass('scrollmagic-parallax-enter-'+countSMParallaxEnter);

                            console.log("hey whats up !");
                            /* ***** ScrollMagic - Parallax Data Y ***** */
                            if(thisSMParallaxEnter.data("sm-parallax-y") !== undefined){
                                smParallaxEnterDataY = thisSMParallaxEnter.data("sm-parallax-y") / 2;

                                tweenSMParallaxEnter = TweenMax.fromTo(thisSMParallaxEnter, 1, {y:-smParallaxEnterDataY, ease: Power0.easeIn}, {y:smParallaxEnterDataY, ease: Power0.easeOut, onComplete: functionScrollMagicDone, onCompleteParams:[thisSMParallaxEnter]});
                            }else{
                                smParallaxEnterDataY = 100 / 2;
                            }

                            if(thisSMParallaxEnter.data("sm-parallax-opacity") !== undefined){
                                tweenSMParallaxEnter = TweenMax.fromTo(thisSMParallaxEnter, 1, {opacity:0, ease: Power0.easeIn}, {opacity:1, ease: Power0.easeOut});
                            }

                            tweenSMParallaxEnter = TweenMax.fromTo(thisSMParallaxEnter, 1, {scale:0.8, ease: Power0.easeIn}, {scale:1, ease: Power0.easeOut, onComplete: functionScrollMagicDone, onCompleteParams:[thisSMParallaxEnter]});

                            sceneSMParallaxEnter = new ScrollMagic.Scene({triggerElement: '.scrollmagic-parallax-enter-'+countSMParallaxEnter})
                            .setTween(tweenSMParallaxEnter)
                            .reverse(false)
                            .addTo(controllerSMParallaxEnter);

                            countSMParallaxEnter++;
                        });
                    }
                }

                /* ***** ScrollMagic - Count Up Scroll ***** */
                if($('.scrollmagic-count-up').length){
                    controllerSMCountUp = new ScrollMagic.Controller();

                    countSMCountUp = 1;
                    $(".scrollmagic-count-up").each(function(index){
                        thisSMCountUp = $(this);
                        thisSMCountUp.attr('id','scrollmagic-count-up-'+countSMCountUp);
                        thisSMCountUp.addClass('scrollmagic-count-up-'+countSMCountUp);

                        smOffsetAnimation = -(($(window).height() / 10) * 5);

                        sceneSMCountUp = new ScrollMagic.Scene({
                            triggerElement: '.scrollmagic-count-up-'+countSMCountUp,
                            offset: smOffsetAnimation
                        }).addTo(controllerSMCountUp).on("enter", function(e){
                            // ***** CountUp
                            var optionsCountUp = {
                                useEasing: true,
                                useGrouping: true,
                                separator: ' ',
                            };
                            var numberCountUp = new CountUp('scrollmagic-count-up-'+countSMCountUp, 0, $('.scrollmagic-count-up-'+countSMCountUp).data("number-up"), 0, 2.5, optionsCountUp);
                            numberCountUp.start();
                        });

                        //controllerSMFollowPage.addScene(sceneSMFollowPage);
                        countSMFollowPage++;
                    });
                }
            }


        //iterate
        this.each(function () {
            var self = $(this);
            _init(self);
        });

        return this;
    };
    
    function functionScrollMagicDone(valueThis){
		valueThis.addClass('scrollmagic-done');
	}
	
    $(window).on('load', function(){
		/*setTimeout(function(){
			$("body").initScrollMagic();
		}, 1600);*/
	});

	/*var controller = new ScrollMagic.Controller();

	// create a scene
	new ScrollMagic.Scene({
        duration: 100,    // the scene should last for a scroll distance of 100px
        offset: 50    // start this scene after scrolling for 50px
    })
    .addTo(controller); // assign the scene to the controller*/

})(jQuery);


// WEBPACK FOOTER //
// ./scripts/modules/scrollmagic.js